<template>
         <div class="inbanner bg-cover">
        <el-image src='images/cp/bg.jpg' width="100"  style="width: 100%; height: auto" fit="fill"></el-image>
  
      <div class="inwrap l-m-c">
        <h2 class="fnt_40 wow fadeInUp animated animated" style="visibility: visible; animation-name: fadeInUp;">产品详情</h2>
        <h3 class="fnt_18 wow fadeInUp animated animated" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">Happy Life</h3>
      </div>
    </div>

    <div class="about" style="  padding-right:250px;padding-left:280px;">
    <div    >
      <el-row>
         <el-col :span="12" class="animate__animated animate__backInRight ">
            <div    >
                      <div class="background-image">
                          <div style="position: relative; z-index: 100;">
                           <el-image @click="showViewer = true"  z-index="999" style=" width: auto;" :src="content.productImg" :onclick="preVIew(srcList)">    </el-image>
                           
                           <el-tag  @click="showViewer = true"  style="  position: absolute;
  top: 50%; /* 或其他位置 */
  left: 48%; /* 或其他位置 */">点击看大图</el-tag>  
                        
                        </div>
                      </div>
     
            </div>
         </el-col>
         <el-col :span="12" class="animate__animated animate__backInLeft "  style=" margin-bottom: 6%;
            color: #686868;
            line-height: 1.8; font-family:  ui-sans-serif; text-align: left; /* 或者使用 left 的简写 left */ font-size:  16px !important;">
                        <div style="padding: 20px;">
      
                <div>
                    <div style="text-align: left;">
                    <div>产品名：{{content.productName}}</div>
                    <div>类型：{{content.productType}}</div>
                    <div>通用名：{{content.productGenericName}}</div>
                    <div>英文名：{{content.englishName}}</div>
                    <div>批准文号：{{content.approvalNumber}}</div>
                    <div>规格：{{content.specifications}}</div>
                    <div>适应症：{{content.indication}}</div>
                </div>
            </div>
        </div>
         </el-col>
      </el-row>
    </div>
    <el-image-viewer
       class="ss"
       v-if="showViewer"
       :url-list="srcList"
       @close="showViewer = false"
       fit="contain"
    ></el-image-viewer>
  </div>
</template>
<style> 
 
.background-image {
   
   position: relative; /* 或者 absolute，具体取决于你的布局需求 */
   z-index: 1 !important; /* 使图片位于底部 */
   padding: 20px;
}
.bo {
 border: 1px solid #bdbdbd;
 padding: 10px;
}
.col-md-4 {
   padding: 10px;
}

.background-image img {

 
   width: 100%; /* 或者其他尺寸 */
   height: 249px; /* 保持图片的宽高比 */
}
</style>
<script>

import { useStore } from 'vuex';
export default {
    data() {
        return {
            showViewer:false,
            content:'',
            srcList: [

            ]
        }
     },
     methods: {
       preVIew(url){
         this.visb=true
       }
     },
     created(){
        const store = useStore();
        console.log(  store.state.productStore.currentProduct);
        this.content=store.state.productStore.currentProduct;
        this.srcList.push(store.state.productStore.currentProduct.productImg)
     },
}
</script>
